export const RESET = 'EXSBPRICEITEM_UPDATE_RESET'
export const SET_ERROR = 'EXSBPRICEITEM_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBPRICEITEM_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBPRICEITEM_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBPRICEITEM_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBPRICEITEM_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBPRICEITEM_UPDATE_UPDATE_RETRIEVED'
